import React, { useEffect, useState } from 'react';
import '../Menubar.css';
import Menubar from '../Menubar';
import Footer from '../Footer';
import usePageTracking from '../PageTracking';
import PreorderTest from './PreorderTest';

function OrderTest() {
  // eslint-disable-next-line max-len
  const [pageTitle, setPageTitle] = useState('Begin Course Registration');
  useEffect(() => {
    document.title = pageTitle; // Set the page title to the current state value
  }, [pageTitle]);
  usePageTracking();
  return (
    <>
      <Menubar />
      <div className='d-flex'>
        <div className='col'>
          <PreorderTest />
        </div>
      </div>
      <Footer />
    </>
  );
}
export default OrderTest;
